import apiClient from './axiosClient';

const getOverlappingRegionRequest = (coordinates: [number, number]) => {
  return apiClient.get(`/regions/overlap/${coordinates.join(',')}`).then(res => res.data);
};

export default getOverlappingRegionRequest;
